import { Component, OnInit } from '@angular/core';
import { EquipamentoGrupo } from '../equipamento.model';
import { GenerateTableColumn, GenerateTablePageEvent, GenerateTablePagination } from 'src/app/shared/components';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EquipamentoGrupoService } from './equipamento-grupo.service';
import { catchErr } from 'src/app/shared/utils';
import { Pagination } from 'src/app/shared/models';
import { MatDialog } from '@angular/material/dialog';
import { ImgDialog } from '../../shared/components/img-dialog.component';

@Component({
    selector: 'equipamento-grupo',
    templateUrl: './equipamento-grupo.component.html',
    standalone: false
})
export class EquipamentoGrupoComponent implements OnInit {
    loading = true;
    filter: string;
    dataSource: EquipamentoGrupo[];
    pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 }
    columns: GenerateTableColumn[] = [
        { header: 'Nome', attr: 'nome' },
        { header: 'Tipo', attr: 'tipo' },
        { header: 'Informações Adicionais', attr: 'descricao' },
        {
            header: 'Imagens',
            template: (rowData: EquipamentoGrupo) => rowData.imagens && rowData.imagens.length ? `<span class="material-symbols-outlined text-primary pointer">photo_library</span>` : '---',
            click: {
              action: (rowData: EquipamentoGrupo) => rowData.imagens && rowData.imagens.length ? this.openDialog(rowData) : null
            }
        }, {
            tdClass: 'td-w-auto',
            btnProps: { label: 'Editar' },
            click: {
              action: (rowData: EquipamentoGrupo) => this.router.navigateByUrl(`/equipamento/grupo/${rowData.id}/editar`)
            }
        }
    ]

    constructor(
        private dialog: MatDialog,
        private grupoService: EquipamentoGrupoService,
        private router: Router,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        this.search();
    }

    search(pageEvent?: GenerateTablePageEvent) {
        this.loading = true;
        this.pagination.current = pageEvent ? pageEvent.current : this.pagination.current
        this.pagination.pageSize = pageEvent ? pageEvent.pageSize : this.pagination.pageSize

        console.log('equipamento grupo filter: ', this.filter);

        this.grupoService.getPaginated<EquipamentoGrupo>(this.pagination.current, this.pagination.pageSize, this.filter).subscribe({
            next: (res: Pagination<EquipamentoGrupo>) => {
                this.dataSource = res.data.map((gp) => ({ ...gp, tipo: gp.tipo.nome }));
                this.pagination.total = res.total;
            }, error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    private openDialog(grupo: EquipamentoGrupo) {
        this.dialog.open(ImgDialog, { data: grupo });
    }
}